import { ArrowDown } from './ArrowDown';
import { ArrowUp } from './ArrowUp';
import { Badge } from './Badge';
import { BriefCase } from './BriefCase';
import { CalendarToday } from './CalendarToday';
import { Cancel } from './Cancel';
import { Check } from './Check';
import { CheckCircleOutline } from './CheckCircleOutiline';
import { ChevronLeft } from './ChevronLeft';
import { ChevronRight } from './ChevronRight';
import { Close } from './Close';
import { Error } from './Error';
import { GrowthChart } from './GrowthChart';
import { InfoOutline } from './InfoOutline';
import { List } from './List';
import { MoneyOutline } from './MoneyOutline';
import { OpenInNew } from './OpenInNew';
import { People } from './People';
import { Planet } from './Planet';
import { Spinner } from './Spinner';
import { Timelapse } from './Timelapse';
import { IconProps } from './types';

export const Icon = ({ svgProps, pathProps, type }: IconProps) => {
  switch (type) {
    case 'badge':
      return <Badge svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />;
    case 'close':
      return <Close svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />;
    case 'planet':
      return <Planet svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />;
    case 'growth-chart':
      return (
        <GrowthChart svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'brief-case':
      return (
        <BriefCase svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'list':
      return <List svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />;
    case 'check-outline':
      return (
        <CheckCircleOutline
          svgProps={{ ...svgProps }}
          pathProps={{ ...pathProps }}
        />
      );
    case 'error':
      return <Error svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />;
    case 'cancel':
      return <Cancel svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />;
    case 'spinner':
      return (
        <Spinner svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'check':
      return <Check svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />;
    case 'arrow-up':
      return (
        <ArrowUp svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'arrow-down':
      return (
        <ArrowDown svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'money-outline':
      return (
        <MoneyOutline svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'people':
      return <People svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />;
    case 'info-outline':
      return (
        <InfoOutline svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'open-in-new':
      return (
        <OpenInNew svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'chevron-left':
      return (
        <ChevronLeft svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'chevron-right':
      return (
        <ChevronRight svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    case 'calendar-today':
      return (
        <CalendarToday
          svgProps={{ ...svgProps }}
          pathProps={{ ...pathProps }}
        />
      );
    case 'timelapse':
      return (
        <Timelapse svgProps={{ ...svgProps }} pathProps={{ ...pathProps }} />
      );
    default:
      return null;
  }
};
